import React, { useState } from "react";
import { FaTelegram, FaWhatsapp, FaRobot } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";

const FloatingBotButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 flex flex-col items-end">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            className="flex flex-col gap-2 mb-4 origin-bottom-right"
          >
            <div className="bg-white border border-gray-200 p-4 rounded-lg flex flex-col gap-3 min-w-[240px] max-w-[calc(100vw-2rem)] sm:max-w-sm shadow-2xl">
              {/* Header */}
              <div className="pb-3 border-b border-gray-100 flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center relative text-primary">
                  <FaRobot size={20} />
                  <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white rounded-full"></span>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-dark leading-tight">eWings Bot</h4>
                  <span className="text-xs text-gray-500 font-medium">Online and ready to help</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col gap-2.5 pt-1">
                <a
                  href="https://t.me/EwingsEducation_bot"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-x-3 bg-[#0088cc] hover:bg-[#0077b3] text-white px-4 py-3 rounded-lg transition-all duration-300 font-medium text-sm"
                >
                  <FaTelegram size={20} />
                  Chat on Telegram
                </a>
                <a
                  href="https://wa.me/94713444555"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-x-3 bg-[#25D366] hover:bg-[#20bd5a] text-white px-4 py-3 rounded-lg transition-all duration-300 font-medium text-sm"
                >
                  <FaWhatsapp size={20} />
                  Chat on WhatsApp
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="relative">
        {!isOpen && (
          <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping duration-1000"></span>
        )}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="relative w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full flex items-center justify-center hover:-translate-y-1 transition-all duration-300 shadow-xl focus:outline-none overflow-hidden"
        >
          <AnimatePresence exitBeforeEnter={true}>
            {isOpen ? (
              <motion.div
                key="close"
                initial={{ rotate: -180, scale: 0.3, opacity: 0 }}
                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                exit={{ rotate: 180, scale: 0.3, opacity: 0 }}
                transition={{ type: "spring", stiffness: 260, damping: 25 }}
                className="absolute inset-0 flex items-center justify-center"
              >
                <MdClose size={26} />
              </motion.div>
            ) : (
              <motion.div
                key="bot"
                initial={{ rotate: 180, scale: 0.3, opacity: 0 }}
                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                exit={{ rotate: -180, scale: 0.3, opacity: 0 }}
                transition={{ type: "spring", stiffness: 260, damping: 25 }}
                className="absolute inset-0 flex items-center justify-center"
              >
                <FaWhatsapp size={28} />
              </motion.div>
            )}
          </AnimatePresence>
        </button>
      </div>
    </div>
  );
};

export default FloatingBotButton;
